import { type Common } from './common.js';
import { type CreateValues, type VpnConnection } from './models/vpnConnections.js';

export class API {
  baseEndpoint = '/vpn-connections';
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<VpnConnection[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<VpnConnection> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<VpnConnection> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }
}
